import { render, staticRenderFns } from "./PurchaseProduct.vue?vue&type=template&id=5140a69c&scoped=true"
import script from "./PurchaseProduct.vue?vue&type=script&lang=js"
export * from "./PurchaseProduct.vue?vue&type=script&lang=js"
import style0 from "./PurchaseProduct.vue?vue&type=style&index=0&id=5140a69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140a69c",
  null
  
)

export default component.exports